/* SILENCE theme runtime. Replaces the React state from the Next.js storefront
   with small, dependency-free modules. Everything is progressive: links and
   forms still work without JavaScript. */
(function () {
  'use strict';

  var config = {};
  try {
    config = JSON.parse((document.getElementById('silence-config') || {}).textContent || '{}');
  } catch (e) { config = {}; }
  var routes = config.routes || {};
  var strings = config.strings || {};

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var pad2 = function (n) { return String(n).padStart(2, '0'); };

  /* ------------------------------------------------------------------ theme */
  function applyTheme(theme) {
    var root = document.documentElement;
    root.dataset.theme = theme;
    root.dataset.themeSource = 'user';
    root.style.colorScheme = theme;
    var meta = $('meta[data-silence-theme-color]');
    if (meta) meta.content = theme === 'dark' ? '#10110f' : '#efede6';
    syncToggles();
  }
  function syncToggles() {
    var theme = document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light';
    var next = theme === 'dark' ? 'light' : 'dark';
    $$('[data-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
      btn.setAttribute('aria-label', 'Switch to ' + next + ' mode');
      btn.setAttribute('title', 'Switch to ' + next + ' mode');
      var label = $('[data-theme-toggle-label]', btn);
      if (label) label.textContent = next + ' mode';
    });
  }
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-theme-toggle]');
    if (!btn) return;
    var next = document.documentElement.dataset.theme === 'dark' ? 'light' : 'dark';
    try { window.localStorage.setItem('silence-theme', next); } catch (e) { /* storage blocked */ }
    applyTheme(next);
  });

  /* --------------------------------------------------------------- overlays */
  var overlayStack = [];
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function lockScroll() {
    document.documentElement.style.overflow = overlayStack.length ? 'hidden' : '';
  }

  function openOverlay(entry) {
    if (!entry.panel || overlayStack.indexOf(entry) !== -1) return;
    entry.returnFocus = document.activeElement;
    if (entry.panel.hasAttribute('hidden')) entry.panel.hidden = false;
    if (entry.backdrop) { entry.backdrop.hidden = false; entry.backdrop.classList.add('is-visible'); }
    entry.panel.removeAttribute('inert');
    // Allow the browser to apply the starting state before transitioning.
    window.requestAnimationFrame(function () { entry.panel.classList.add('is-open'); });
    overlayStack.push(entry);
    lockScroll();
    var target = (entry.initialFocus && $(entry.initialFocus, entry.panel)) || $(FOCUSABLE, entry.panel) || entry.panel;
    window.setTimeout(function () { target.focus({ preventScroll: true }); }, 30);
    if (entry.onOpen) entry.onOpen();
  }

  function closeOverlay(entry, restoreFocus) {
    var index = overlayStack.indexOf(entry);
    if (index === -1) return;
    overlayStack.splice(index, 1);
    entry.panel.classList.remove('is-open');
    if (entry.backdrop) entry.backdrop.classList.remove('is-visible');
    entry.panel.setAttribute('inert', '');
    var finish = function () {
      if (overlayStack.indexOf(entry) !== -1) return;
      if (entry.hideWhenClosed) {
        entry.panel.hidden = true;
        if (entry.backdrop) entry.backdrop.hidden = true;
      } else if (entry.backdrop && entry.backdropHidden) {
        entry.backdrop.hidden = true;
      }
    };
    if (entry.hideWhenClosed || entry.backdropHidden) window.setTimeout(finish, 260);
    lockScroll();
    if (restoreFocus !== false && entry.returnFocus && document.contains(entry.returnFocus)) {
      entry.returnFocus.focus({ preventScroll: true });
    }
    if (entry.onClose) entry.onClose();
  }

  document.addEventListener('keydown', function (event) {
    var top = overlayStack[overlayStack.length - 1];
    if (!top) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeOverlay(top);
      return;
    }
    if (event.key === 'Tab') {
      var nodes = $$(FOCUSABLE, top.panel).filter(function (n) { return n.offsetParent !== null; });
      if (!nodes.length) { event.preventDefault(); top.panel.focus(); return; }
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === top.panel)) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    }
  });

  /* ----------------------------------------------------------- header menus */
  var menu = {
    panel: $('#mobile-menu'),
    initialFocus: '[data-close-menu].icon-button',
    onOpen: function () { var b = $('[data-open-menu]'); if (b) b.setAttribute('aria-expanded', 'true'); },
    onClose: function () {
      var b = $('[data-open-menu]'); if (b) b.setAttribute('aria-expanded', 'false');
    }
  };
  var search = {
    panel: $('#product-search-dialog'),
    backdrop: $('.search-panel__backdrop'),
    backdropHidden: true,
    initialFocus: '[data-search-input]',
    onOpen: function () { var b = $('[data-open-search]'); if (b) b.setAttribute('aria-expanded', 'true'); },
    onClose: function () { var b = $('[data-open-search]'); if (b) b.setAttribute('aria-expanded', 'false'); }
  };
  var drawer = {
    panel: $('[data-cart-drawer]'),
    backdrop: $('.cart-drawer__backdrop'),
    initialFocus: '.cart-drawer__header .icon-button'
  };

  document.addEventListener('click', function (event) {
    var t = event.target;
    var openMenu = t.closest('[data-open-menu]');
    if (openMenu) { closeOverlay(search, false); openOverlay(menu); return; }
    var closeMenuEl = t.closest('[data-close-menu]');
    if (closeMenuEl) {
      // Anchors keep navigating; buttons only close.
      closeOverlay(menu, !closeMenuEl.matches('a'));
      return;
    }
    var openSearch = t.closest('[data-open-search]');
    if (openSearch) { closeOverlay(menu, false); openOverlay(search); return; }
    if (t.closest('[data-close-search]')) { closeOverlay(search); return; }
    var toggleStore = t.closest('[data-toggle-store]');
    if (toggleStore) {
      var panel = document.getElementById('mobile-store-collections');
      var expanded = toggleStore.getAttribute('aria-expanded') === 'true';
      toggleStore.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      toggleStore.setAttribute('aria-label', (expanded ? 'Expand' : 'Collapse') + ' Store collections');
      var sign = toggleStore.querySelector('span');
      if (sign) sign.textContent = expanded ? '+' : '-';
      if (panel) panel.hidden = expanded;
      return;
    }
    var openCartEl = t.closest('[data-open-cart]');
    if (openCartEl && drawer.panel && document.body.classList.contains('template-cart') === false) {
      event.preventDefault();
      closeOverlay(menu, false);
      closeOverlay(search, false);
      openOverlay(drawer);
      return;
    }
    if (t.closest('[data-close-cart]')) {
      closeOverlay(drawer, !t.closest('a'));
      return;
    }
  });

  if (window.matchMedia) {
    var desktop = window.matchMedia('(min-width: 901px)');
    var onBreakpoint = function () { if (desktop.matches) closeOverlay(menu, false); };
    if (desktop.addEventListener) desktop.addEventListener('change', onBreakpoint);
  }

  /* ------------------------------------------------------------------- cart */
  function setCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = '(' + pad2(count) + ')'; });
    $$('a[data-open-cart].bag-button').forEach(function (el) {
      el.setAttribute('aria-label', 'Shopping bag, ' + count + ' items');
    });
  }

  function showCartError(message) {
    var box = $('[data-cart-error]');
    if (!box) return;
    $('[data-cart-error-text]', box).textContent = message || strings.cartError || 'We could not update your bag.';
    box.hidden = false;
  }
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-error-dismiss]')) {
      var box = $('[data-cart-error]'); if (box) box.hidden = true;
    }
  });

  function renderDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var swaps = ['[data-cart-title]', '[data-cart-body]', '.cart-drawer__footer'];
    swaps.forEach(function (sel) {
      var fresh = $(sel, doc);
      var current = $(sel, document);
      if (fresh && current) current.replaceWith(fresh);
    });
  }

  var cartBusy = false;
  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) {
          var err = new Error(json.description || json.message || strings.cartError);
          err.payload = json;
          throw err;
        }
        return json;
      });
    });
  }

  function applyCartResponse(json) {
    var count = typeof json.item_count === 'number' ? json.item_count : null;
    if (json.sections && json.sections['cart-drawer']) renderDrawer(json.sections['cart-drawer']);
    if (count !== null) setCartCount(count);
  }

  function changeLine(key, quantity, line) {
    if (cartBusy) return;
    cartBusy = true;
    var onPage = !!$('[data-cart-page]');
    if (line) line.setAttribute('aria-busy', 'true');
    cartRequest(routes.cart_change_url || '/cart/change.js', {
      id: key,
      quantity: quantity,
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    }).then(function (json) {
      if (onPage) { window.location.reload(); return; }
      applyCartResponse(json);
    }).catch(function (err) {
      showCartError(err.message);
      if (onPage) console.error(err);
    }).then(function () {
      cartBusy = false;
      if (line) line.removeAttribute('aria-busy');
    });
  }

  document.addEventListener('click', function (event) {
    var line = event.target.closest('[data-cart-line]');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var qty = parseInt(line.getAttribute('data-quantity'), 10) || 1;
    if (event.target.closest('[data-cart-decrease]')) { changeLine(key, qty - 1, line); }
    else if (event.target.closest('[data-cart-increase]')) {
      var max = parseInt(line.getAttribute('data-max'), 10);
      if (!isNaN(max) && qty >= max) return;
      changeLine(key, qty + 1, line);
    } else if (event.target.closest('[data-cart-remove]')) { changeLine(key, 0, line); }
  });

  /* --------------------------------------------------------------- products */
  function initProduct(root) {
    var jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var variants = product.variants || [];
    var optionCount = (product.options || []).length;
    var hasOptions = root.getAttribute('data-has-options') === 'true';
    var form = $('[data-product-form]', root);
    var idInput = $('[data-variant-id]', root);
    var addBtn = $('[data-add]', root);
    var addLabel = $('[data-add-label]', root);
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare]', root);
    var availEl = $('[data-availability]', root);
    var errorEl = $('[data-form-error]', root);
    var sizeIndex = parseInt(root.getAttribute('data-size-index'), 10);
    var money = function (cents) {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(cents / 100);
      } catch (e) { return '$' + (cents / 100).toFixed(2); }
    };

    var selections = [];
    for (var i = 0; i < optionCount; i++) {
      var picked = $('[data-option-button][data-position="' + i + '"].is-selected', root);
      selections[i] = picked ? picked.getAttribute('data-value') : '';
    }

    function matches(variant, sel) {
      for (var k = 0; k < optionCount; k++) {
        if (variant.options[k] !== sel[k]) return false;
      }
      return true;
    }
    function isAvailable(position, value, sel) {
      return variants.some(function (v) {
        if (!v.available) return false;
        for (var k = 0; k < position; k++) if (v.options[k] !== sel[k]) return false;
        return v.options[position] === value;
      });
    }
    function currentVariant() {
      if (!hasOptions) return variants[0];
      if (selections.some(function (s) { return !s; })) return null;
      return variants.filter(function (v) { return matches(v, selections); })[0] || null;
    }
    function anyAvailable() { return variants.some(function (v) { return v.available; }); }

    function paintOptions() {
      $$('[data-option-button]', root).forEach(function (btn) {
        var pos = parseInt(btn.getAttribute('data-position'), 10);
        var val = btn.getAttribute('data-value');
        var selected = selections[pos] === val;
        var available = isAvailable(pos, val, selections);
        btn.classList.toggle('is-selected', selected);
        btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
        btn.disabled = !available;
        var hint = $('.sr-only', btn);
        if (!available && !hint) { var s = document.createElement('span'); s.className = 'sr-only'; s.textContent = ' Unavailable'; btn.appendChild(s); }
        if (available && hint) hint.remove();
      });
      for (var p = 0; p < optionCount; p++) {
        var label = $('[data-option-label="' + p + '"]', root);
        if (label) label.textContent = selections[p] || strings.selectOne || 'Select one';
      }
    }

    function paintPurchase(variant) {
      var soldOutAll = !anyAvailable();
      var label;
      var canAdd = false;
      if (soldOutAll) label = strings.soldOut || 'Sold out';
      else if (!variant) label = strings.selectOptions || 'Select options';
      else if (variant.available) { label = strings.addToBag || 'Add to bag'; canAdd = true; }
      else label = strings.unavailable || 'Unavailable';
      if (addLabel) addLabel.textContent = label;
      if (addBtn) addBtn.disabled = !canAdd;
      if (idInput) idInput.value = variant ? variant.id : '';
      if (variant) {
        if (priceEl) priceEl.textContent = money(variant.price);
        if (compareEl) {
          var showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
          compareEl.hidden = !showCompare;
          if (showCompare) compareEl.textContent = money(variant.compare_at_price);
        }
        if (availEl) {
          availEl.textContent = variant.available ? (strings.available || 'Available') : (strings.soldOut || 'Sold out');
          availEl.classList.toggle('is-available', !!variant.available);
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      } else if (availEl) {
        availEl.textContent = soldOutAll ? (strings.soldOut || 'Sold out') : (strings.selectOptions || 'Select options');
        availEl.classList.remove('is-available');
      }
    }

    /* gallery */
    var items = $$('[data-gallery-item]', root);
    var thumbs = $$('[data-gallery-thumb]', root);
    var mainImg = $('[data-gallery-main]', root);
    var positionEl = $('[data-gallery-position]', root);
    var galleryEl = $('[data-gallery]', root);
    var stack = $('[data-gallery-stack]', root);
    var active = 0;
    var total = Math.max(items.length, thumbs.length);

    function setActive(index) {
      if (!total) return;
      active = (index + total) % total;
      var thumb = thumbs[active];
      if (thumb && mainImg) {
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = thumb.getAttribute('data-src');
        mainImg.alt = thumb.getAttribute('data-alt') || '';
      }
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === active);
        t.setAttribute('aria-pressed', i === active ? 'true' : 'false');
      });
      if (positionEl) positionEl.textContent = pad2(active + 1) + ' / ' + pad2(total);
    }
    function showVariantImage(variant) {
      var id = variant && variant.featured_image && variant.featured_image.id;
      var index = -1;
      items.forEach(function (it, i) { if (String(it.getAttribute('data-image-id')) === String(id)) index = i; });
      if (index < 0) return;
      setActive(index);
      var target = items[index];
      if (galleryEl && target && target.getClientRects().length > 0) {
        galleryEl.scrollTo({ top: target.getBoundingClientRect().top - galleryEl.getBoundingClientRect().top + galleryEl.scrollTop, behavior: 'auto' });
      }
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { setActive(i); }); });
    var prev = $('[data-gallery-prev]', root); var next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { setActive(active - 1); });
    if (next) next.addEventListener('click', function () { setActive(active + 1); });
    if (stack) {
      stack.addEventListener('keydown', function (event) {
        var el = stack.parentElement;
        var step = Math.max(el.clientHeight * 0.8, 160);
        var top;
        if (event.key === 'ArrowDown' || event.key === 'PageDown') top = el.scrollTop + step;
        else if (event.key === 'ArrowUp' || event.key === 'PageUp') top = el.scrollTop - step;
        else if (event.key === 'Home') top = 0;
        else if (event.key === 'End') top = el.scrollHeight;
        else return;
        event.preventDefault();
        el.scrollTo({ top: top, behavior: 'auto' });
      });
    }

    /* option clicks */
    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-option-button]');
      if (!btn || btn.disabled) return;
      var pos = parseInt(btn.getAttribute('data-position'), 10);
      selections[pos] = btn.getAttribute('data-value');
      // Reconcile later options so the combination stays purchasable.
      for (var q = pos + 1; q < optionCount; q++) {
        var values = $$('[data-option-button][data-position="' + q + '"]', root).map(function (b) { return b.getAttribute('data-value'); });
        if (selections[q] && !isAvailable(q, selections[q], selections)) {
          var fallback = values.filter(function (v) { return isAvailable(q, v, selections); })[0];
          selections[q] = fallback || '';
        }
      }
      var variant = currentVariant();
      paintOptions();
      paintPurchase(variant);
      showVariantImage(variant);
      if (errorEl) errorEl.hidden = true;
    });

    /* add to cart */
    if (form) {
      form.addEventListener('submit', function (event) {
        var variant = currentVariant();
        if (!variant || !variant.available) { event.preventDefault(); return; }
        var wantsDrawer = !!drawer.panel;
        if (!wantsDrawer) return; // native submit
        event.preventDefault();
        if (form.getAttribute('aria-busy') === 'true') return;
        form.setAttribute('aria-busy', 'true');
        if (addLabel) addLabel.textContent = strings.adding || 'Adding to bag';
        if (addBtn) addBtn.disabled = true;
        var payload = { items: [{ id: variant.id, quantity: 1 }], sections: 'cart-drawer', sections_url: window.location.pathname };
        cartRequest(routes.cart_add_url ? routes.cart_add_url.replace(/(\.js)?$/, '.js') : '/cart/add.js', payload)
          .then(function (json) {
            return fetch((routes.cart_url || '/cart') + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
              if (json.sections) cart.sections = json.sections;
              applyCartResponse(cart);
              if (errorEl) errorEl.hidden = true;
              openOverlay(drawer);
            });
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message || strings.cartError; errorEl.hidden = false; }
          })
          .then(function () {
            form.removeAttribute('aria-busy');
            paintPurchase(currentVariant());
          });
      });
    }

    /* enlarge dialog */
    var dialog = $('[data-image-dialog]', root);
    if (dialog) {
      var dialogEntry = { panel: dialog, backdrop: $('[data-image-close].size-guide-modal__backdrop', root), hideWhenClosed: true, initialFocus: '.icon-button' };
      var dialogImg = $('[data-image-dialog-img]', dialog);
      var zoomBtn = $('[data-image-zoom]', dialog);
      var zoomWrap = $('[data-image-zoom-wrap]', dialog);
      var zoomed = false;
      var setZoom = function (on) {
        zoomed = on;
        zoomWrap.style.width = on ? '200%' : '100%';
        zoomBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        zoomBtn.textContent = on ? (strings.zoomOut || 'Zoom out') : (strings.zoomIn || 'Zoom in');
      };
      var showImage = function (src, alt) {
        setZoom(false);
        dialogImg.src = src;
        dialogImg.alt = alt || '';
        openOverlay(dialogEntry);
      };
      root.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-enlarge]');
        if (trigger) { showImage(trigger.getAttribute('data-large'), trigger.getAttribute('data-alt')); return; }
        if (event.target.closest('[data-enlarge-active]')) {
          var t = items[active] && $('[data-enlarge]', items[active]);
          if (t) showImage(t.getAttribute('data-large'), t.getAttribute('data-alt'));
          else if (mainImg) showImage(mainImg.src, mainImg.alt);
          return;
        }
        if (event.target.closest('[data-image-close]')) closeOverlay(dialogEntry);
        if (event.target.closest('[data-image-zoom]')) setZoom(!zoomed);
      });
    }

    /* size guide */
    var guideScript = $('[data-size-guide]', root);
    var guideModal = $('[data-size-guide-modal]', root);
    if (guideScript && guideModal) {
      var guide = null;
      try {
        guide = JSON.parse(guideScript.textContent);
        if (typeof guide === 'string') guide = JSON.parse(guide);
      } catch (e) { guide = null; }
      var valid = guide && Array.isArray(guide.columns) && Array.isArray(guide.rows) && guide.columns.length && guide.rows.length;
      if (!valid) {
        $$('[data-size-guide-open]', root).forEach(function (b) { b.closest('.product-options__size-guide') ? b.closest('.product-options__size-guide').remove() : b.remove(); });
        var note = $('[data-size-guide-note]', root);
        if (note && note.closest('details')) note.closest('details').remove();
      } else {
        var esc = function (s) { var d = document.createElement('div'); d.textContent = String(s); return d.innerHTML; };
        var kind = guide.measurementType === 'garment' ? 'Garment measurements' : guide.measurementType === 'body' ? 'Body measurements' : 'Measurement reference';
        var html = '<p class="size-guide-modal__measurement-type">' + kind + '</p><div class="size-guide-modal__table-wrap"><table><caption class="sr-only">' + esc(product.title) + ' ' + kind.toLowerCase() + ' in ' + esc(guide.unit || '') + '</caption><thead><tr><th scope="col">Measurement</th>' +
          guide.columns.map(function (c) { return '<th scope="col">' + esc(c) + '</th>'; }).join('') + '</tr></thead><tbody>' +
          guide.rows.map(function (r) { return '<tr><th scope="row">' + esc(r.label) + '</th>' + (r.values || []).map(function (v) { return '<td>' + esc(v) + '</td>'; }).join('') + '</tr>'; }).join('') +
          '</tbody></table></div>' + (guide.instructions ? '<p>' + esc(guide.instructions) + '</p>' : '');
        $('[data-size-guide-body]', guideModal).innerHTML = html;
        $$('[data-size-guide-unit]', root).forEach(function (u) { u.textContent = guide.unit || ''; });
        var noteEl = $('[data-size-guide-note]', root);
        if (noteEl) noteEl.textContent = guide.measurementType === 'garment' ? 'Garment measurements. Compare with a piece you already own.' : guide.measurementType === 'body' ? 'Body measurements. Measure yourself before selecting a size.' : noteEl.textContent;
        var guideEntry = { panel: guideModal, backdrop: $('[data-size-guide-close].size-guide-modal__backdrop', root), hideWhenClosed: true, initialFocus: '.icon-button' };
        root.addEventListener('click', function (event) {
          if (event.target.closest('[data-size-guide-open]')) openOverlay(guideEntry);
          else if (event.target.closest('[data-size-guide-close]')) closeOverlay(guideEntry);
        });
      }
    }

    paintOptions();
    paintPurchase(currentVariant());
    // Honour ?variant= on first paint.
    var wanted = new URL(window.location.href).searchParams.get('variant');
    if (wanted && hasOptions) {
      var found = variants.filter(function (v) { return String(v.id) === wanted; })[0];
      if (found) { selections = found.options.slice(); paintOptions(); paintPurchase(found); showVariantImage(found); }
    }
  }
  $$('[data-product]').forEach(initProduct);

  /* related products */
  $$('[data-related]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || $('.product-grid', el)) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-related]', doc);
      if (fresh && $('.product-grid', fresh)) el.innerHTML = fresh.innerHTML;
      else el.hidden = true;
    }).catch(function () { el.hidden = true; });
  });

  /* ----------------------------------------------------------------- reveal */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealEls = $$('[data-reveal]');
  if (!('IntersectionObserver' in window) || reduceMotion) {
    revealEls.forEach(function (el) { el.classList.add('is-in-view'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in-view'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* --------------------------------------------------------- scroll progress */
  var bar = $('[data-scroll-progress]');
  if (bar) {
    if (reduceMotion) { bar.remove(); }
    else {
      bar.style.transform = 'scaleX(0)';
      var tick = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(window.scrollY / h, 1) : 0) + ')';
      };
      window.addEventListener('scroll', tick, { passive: true });
      window.addEventListener('resize', tick);
      tick();
    }
  }

  /* -------------------------------------------------------------- countdown */
  function initCountdown(el) {
    var iso = el.getAttribute('data-launch-at');
    var launch = Date.parse(iso);
    var label = el.getAttribute('data-label') || 'Drop';
    var pending = el.getAttribute('data-pending') || 'Transmission pending';
    var showPending = function () {
      el.className = 'countdown countdown--pending';
      el.removeAttribute('role');
      el.removeAttribute('aria-label');
      el.innerHTML = '<span class="countdown__status" aria-hidden="true"></span><p class="countdown__pending"></p>';
      el.querySelector('p').textContent = pending;
    };
    if (isNaN(launch)) { showPending(); return; }
    var units = function (v, l) { return '<div class="countdown__unit"><span class="countdown__value" aria-hidden="true">' + v + '</span><span class="countdown__label">' + l + '</span></div>'; };
    var sep = '<span class="countdown__separator" aria-hidden="true">:</span>';
    var timer;
    var render = function () {
      var diff = launch - Date.now();
      if (diff <= 0) { showPending(); return; }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      var dayText = d < 100 ? pad2(d) : String(d);
      el.setAttribute('role', 'timer');
      el.setAttribute('aria-label', label + ' launch countdown');
      el.innerHTML = '<span class="sr-only">' + label + ' scheduled in ' + d + ' days, ' + h + ' hours, ' + m + ' minutes.</span>' +
        units(dayText, 'Days') + sep + units(pad2(h), 'Hours') + sep + units(pad2(m), 'Min') + sep + units(pad2(sec), 'Sec');
      timer = window.setTimeout(render, 1000);
    };
    render();
  }
  $$('[data-countdown]').forEach(initCountdown);

  /* ------------------------------------------------------------------ forms */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form.newsletter-form, form[data-waitlist-form]')) return;
    var email = form.querySelector('input[type="email"]');
    var consent = form.querySelector('input[name="consent"]');
    var message = form.querySelector('[id$="-message"]');
    var fail = function (text, field) {
      event.preventDefault();
      if (message) { message.textContent = text; message.setAttribute('role', 'alert'); }
      if (field) { field.setAttribute('aria-invalid', 'true'); field.focus(); }
    };
    if (email) email.removeAttribute('aria-invalid');
    if (consent) consent.removeAttribute('aria-invalid');
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
      return fail('Enter a valid email to receive the next drop.', email);
    }
    if (consent && !consent.checked) {
      return fail(strings.newsletterConsent || 'Please confirm marketing consent.', consent);
    }
    // Waitlist: carry the optional size preference as a customer tag.
    var tags = form.querySelector('[data-waitlist-tags]');
    var size = form.querySelector('[data-waitlist-size]:checked');
    if (tags && size) tags.value = 'waitlist,drop-001,size:' + size.value;
  });

  /* ---------------------------------------------------------------- startup */
  syncToggles();
  setCartCount(typeof config.cartCount === 'number' ? config.cartCount : 0);
  document.addEventListener('shopify:section:load', function () { syncToggles(); });
})();
(function(){document.querySelectorAll('[data-gallery-stack]').forEach(function(s){var items=s.querySelectorAll('[data-gallery-item]');if(items.length<2)return;var wrap=document.createElement('div');wrap.className='gal-ui';wrap.innerHTML='<button type="button" class="gal-btn gal-btn--prev" aria-label="Previous image">&#8592;</button><span class="gal-count" aria-live="polite"></span><button type="button" class="gal-btn gal-btn--next" aria-label="Next image">&#8594;</button><div class="gal-dots"></div>';s.parentNode.insertBefore(wrap,s.nextSibling);var cnt=wrap.querySelector('.gal-count'),dots=wrap.querySelector('.gal-dots'),cur=0;function go(i){i=Math.max(0,Math.min(items.length-1,i));s.scrollTo({left:i*s.clientWidth,behavior:'smooth'})}items.forEach(function(x,i){var d=document.createElement('button');d.type='button';d.setAttribute('aria-label','Image '+(i+1));d.onclick=function(){go(i)};dots.appendChild(d)});function upd(){var i=Math.round(s.scrollLeft/s.clientWidth);cur=i;cnt.textContent=('0'+(i+1)).slice(-2)+' / '+('0'+items.length).slice(-2);dots.querySelectorAll('button').forEach(function(d,k){d.className=k===i?'is-active':''})}wrap.querySelector('.gal-btn--prev').onclick=function(){go(cur-1)};wrap.querySelector('.gal-btn--next').onclick=function(){go(cur+1)};s.addEventListener('scroll',function(){requestAnimationFrame(upd)},{passive:true});upd()})})();
